import React, { useEffect, useState } from "react";
import DaumPostcodeEmbed from "react-daum-postcode";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Pagination,
  Radio,
  Row,
  Select,
  Table,
} from "antd";
import { Option } from "antd/es/mentions";
import moment from "moment";

import * as XLSX from "xlsx";

import pushApi from "../../../apis/Push.api";
import salesManageApi from "../../../apis/SalesManage.api";
import {
  setLoading,
  setRecordDates,
  setSearchText,
} from "../../../redux/store/common/commonDuck";
import status from "../../../utils/status";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

import OrderDetailComponent from "./OrderDetailComponent";

const DeliveryManageComponet = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const searchText = useSelector((state) => state.common.searchText);
  const setIsSearchText = (value) => dispatch(setSearchText(value));
  const recordDates = useSelector((state) => state.common.recordDates);
  const setDates = (value) => dispatch(setRecordDates(value));
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [orderDeliveryStatus, setOrderDeliveryStatus] = useState({
    deliveryShipping: 0,
    deliveryComplete: 0,
  });
  const [dateType, setDateType] = useState("1week");
  const [searchOptions, setSearchOptions] = useState({
    searchType: "payment_created_at",
    searchStatus: "total",
    searchOrderId: "",
    searchProductName: "",
    funnel: 0,
    name: "",
    phone: "",
    startDate: moment().subtract(7, "days").startOf("day"),
    endDate: moment().endOf("day"),
  });
  const [orderType, setOrderType] = useState("payment_created_at");
  const [orderBy, setOrderBy] = useState("desc");
  const [selectedRowKey, setSelectedRowKey] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [totalSize, setTotalSize] = useState(0);
  const [offset, setOffset] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [deliveryCompanyList, setDeliveryCompanyList] = useState([]);
  const [totalOrderList, setTotalOrderList] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [orderDetail, setOrderDetail] = useState({});
  const [editDeliveryInfo, setEditDeliveryInfo] = useState({});
  const [customerDeliveryInfo, setCustomerDeliveryInfo] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPostalCodeModalOpen, setIsPostalCodeModalOpen] = useState(false);
  const [isDeliveryShippingModalOpen, setIsDeliveryShippingModalOpen] =
    useState(false);
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
  const [validation, setValidation] = useState(false);
  const [uploadExcelDataHeader, setUploadExcelDataHeader] = useState([]);
  const [uploadExcelData, setUploadExcelData] = useState([]);
  const [error, setError] = useState("");

  const searchDateItems = [
    { searchText: "결제일", searchType: "payment_created_at" },
    { searchText: "발송일", searchType: "ship_date" },
    // {searchText: '배송일', searchType: 'delivery_complete_date'}
  ];
  const dateTypeItems = [
    { label: "오늘", value: "today" },
    { label: "1주일", value: "1week" },
    { label: "1개월", value: "1month" },
    { label: "3개월", value: "3month" },
    { label: "6개월", value: "6month" },
  ];
  const orderStatusItems = [
    { label: "전체", value: "total" },
    // {label: '입금대기', value: 'ready'},
    // {label: '입금완료', value: 'paid'},
    // {label: '결제실패', value: 'failed'},
    // {label: '결제취소', value: 'cancelled'},
    { label: "배송준비중", value: "delivery_ready" },
    { label: "배송중", value: "delivery_shipping" },
    { label: "배송완료", value: "delivery_complete" },
    { label: "구매확정", value: "complete" },
    // {label: '취소요청', value: 'cancel_request'},
    // {label: '교환요청', value: 'exchange_request'},
    // {label: '반품요청', value: 'return_request'},
    // {label: '취소완료', value: 'cancel_complete'},
    // {label: '교환완료', value: 'exchange_complete'},
    // {label: '반품완료', value: 'return_complete'}
  ];
  const funnelStatusItems = [
    { label: "전체", value: 0 },
    { label: "검색", value: 1 },
    { label: "전화주문", value: 4 },
    { label: "인플루언서", value: 2 },
    { label: "셀러", value: 5 },
    { label: "공동구매", value: 3 },
  ];
  const orderPair = {
    payment_created_at: "결제일순",
    order_id: "주문번호순",
    // created_at: '주문일시순'
  };
  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      for (const row of selectedRows) {
        if (!editDeliveryInfo.hasOwnProperty(row.order_detail_id)) {
          editDeliveryInfo[row.order_detail_id] = {
            order_id: row.order_id,
            order_detail_id: row.order_detail_id,
            order_detail_status: "delivery_shipping",
            delivery_company: row.delivery_company,
            tracking_number: row.tracking_number,
            ship_date:
              row.ship_date === null || row.ship_date === ""
                ? moment()
                : moment(row.ship_date),
            updated_by: user.id === 724 ? 1 : user.id,
          };
        }
      }
      let difference = Object.keys(editDeliveryInfo).filter(
        (orderDetailKey) => !selectedRowKeys.includes(parseInt(orderDetailKey)),
      );
      if (difference?.length !== 0) {
        for (const orderDetailKey of difference) {
          delete editDeliveryInfo[orderDetailKey];
        }
      }
      setSelectedRowKey(selectedRowKeys);
      setSelectedRow(selectedRows);
    },
  };
  const columns = [
    {
      title: "주문번호",
      width: 90,
      dataIndex: "order_id",
      key: "order_id",
      fixed: "left",
      ellipsis: true,
      sorter: (a, b) => {},
      render: (value, record) => {
        return (
          <span
            className="recommend-inquiry-list-title"
            onClick={() => {
              setOrderDetail(record);
              setIsOrderModalOpen(true);
            }}
          >
            {value}
          </span>
        );
      },
    },
    {
      title: "주문일시",
      // width: 160,
      dataIndex: "created_at",
      key: "created_at",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        }
      },
    },
    {
      title: "상품번호",
      // width: 80,
      dataIndex: "product_id",
      key: "product_id",
      ellipsis: true,
    },
    {
      title: "상품명",
      // width: 200,
      dataIndex: "product_name",
      key: "product_name",
      ellipsis: true,
    },
    {
      title: "옵션명",
      // width: 200,
      dataIndex: "option_title",
      key: "option_title",
      ellipsis: true,
    },
    {
      title: "수량",
      // width: 60,
      dataIndex: "quantity",
      key: "quantity",
      ellipsis: true,
    },
    {
      title: "상품별 총 주문금액",
      // width: 150,
      dataIndex: "total_price",
      key: "total_price",
      ellipsis: true,
      render: (value) => {
        return value.toLocaleString();
      },
    },
    {
      title: "주문상태",
      // width: 90,
      dataIndex: "order_detail_status",
      key: "order_detail_status",
      ellipsis: true,
      render: (value) => {
        return status.orderStatusChange(value);
      },
    },
    {
      title: "택배사",
      // width: 140,
      dataIndex: "delivery_company",
      key: "delivery_company",
      render: (value, record) => {
        if (
          record.order_detail_status === "delivery_ready" ||
          record.order_detail_status === "delivery_shipping"
        ) {
          if (selectedRowKey.includes(record.order_detail_id)) {
            return (
              <Select
                className="order-delivery-company-select"
                placeholder="선택"
                value={
                  editDeliveryInfo[record.order_detail_id].delivery_company
                }
                onChange={(value, e) =>
                  setEditDeliveryInfo({
                    ...editDeliveryInfo,
                    [e.id]: {
                      ...editDeliveryInfo[e.id],
                      delivery_company: value,
                    },
                  })
                }
              >
                {deliveryCompanyList.map((deliveryCompany, idx) => (
                  <Option
                    key={`delivery_company_select_${idx}`}
                    id={record.order_detail_id}
                    value={deliveryCompany.delivery_company_id}
                  >
                    {deliveryCompany.delivery_company_name}
                  </Option>
                ))}
              </Select>
            );
          } else {
            if (value === null || value === "") {
              return value;
            } else {
              const findDeliveryCompany = deliveryCompanyList.find(
                (deliveryCompany) =>
                  deliveryCompany.delivery_company_id === value,
              );
              if (findDeliveryCompany) {
                return findDeliveryCompany.delivery_company_name;
              } else {
                return value;
              }
            }
          }
        } else {
          if (value === null || value === "") {
            return value;
          } else {
            const findDeliveryCompany = deliveryCompanyList.find(
              (deliveryCompany) =>
                deliveryCompany.delivery_company_id === value,
            );
            if (findDeliveryCompany) {
              return findDeliveryCompany.delivery_company_name;
            } else {
              return value;
            }
          }
        }
      },
    },
    {
      title: "송장번호",
      // width: 150,
      dataIndex: "tracking_number",
      key: "tracking_number",
      render: (value, record) => {
        if (
          record.order_detail_status === "delivery_ready" ||
          record.order_detail_status === "delivery_shipping"
        ) {
          if (selectedRowKey.includes(record.order_detail_id)) {
            return (
              <Input
                className="order-tracking-number-input"
                name={record.order_detail_id}
                value={editDeliveryInfo[record.order_detail_id].tracking_number}
                onChange={(e) =>
                  setEditDeliveryInfo({
                    ...editDeliveryInfo,
                    [e.target.name]: {
                      ...editDeliveryInfo[e.target.name],
                      tracking_number: e.target.value,
                    },
                  })
                }
              />
            );
          } else {
            return value;
          }
        } else {
          return value;
        }
      },
    },
    {
      title: "발송처리일",
      width: 100,
      dataIndex: "ship_date",
      key: "ship_date",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value, record) => {
        if (
          record.order_detail_status === "delivery_ready" ||
          record.order_detail_status === "delivery_shipping"
        ) {
          if (selectedRowKey.includes(record.order_detail_id)) {
            return (
              <DatePicker
                className="order-ship-date-input"
                format="YYYY-MM-DD"
                value={editDeliveryInfo[record.order_detail_id].ship_date}
                onChange={(value) =>
                  setEditDeliveryInfo({
                    ...editDeliveryInfo,
                    [record.order_detail_id]: {
                      ...editDeliveryInfo[record.order_detail_id],
                      ship_date: value,
                    },
                  })
                }
              />
            );
          } else {
            if (value === null || value === "") {
              return value;
            } else {
              const date = moment(value).format("YYYY.MM.DD");
              return date;
            }
          }
        } else {
          if (value === null || value === "") {
            return value;
          } else {
            const date = moment(value).format("YYYY.MM.DD");
            return date;
          }
        }
      },
    },
    {
      title: "배송추적",
      // width: 80,
      dataIndex: "",
      key: "",
      render: (value, record) => {
        if (
          record.order_detail_status === "delivery_shipping" ||
          record.order_detail_status === "delivery_complete" ||
          record.order_detail_status === "complete"
        ) {
          return (
            <a
              href={`https://${
                record.goodsflow_service_id
                  ? `www.goodsflow.io/tracking/tXYtiyVnAX/${record.goodsflow_service_id}`
                  : `tracker.delivery/#/${record.delivery_company}/${record.tracking_number}`
              }`}
              target="_blank"
              rel="noreferrer"
            >
              배송추적
            </a>
          );
        } else {
          return "";
        }
      },
    },
    {
      title: "주소",
      // width: '40%',
      dataIndex: "address",
      key: "address",
      ellipsis: true,
      render: (value) => {
        return <div style={{ width: "auto" }}>{value}</div>;
      },
    },
    {
      title: "상세주소",
      // width: 80,
      dataIndex: "address_detail",
      key: "address_detail",
      ellipsis: true,
    },
    {
      title: "배송 요청사항",
      // width: 100,
      dataIndex: "address_request",
      key: "address_request",
      ellipsis: true,
      render: (value) => {
        if (
          value !== null &&
          value !== "" &&
          value !== "배송 시 요청사항을 선택해주세요."
        ) {
          return value;
        } else {
          return "";
        }
      },
    },
    {
      title: "수취인명",
      // width: 80,
      dataIndex: "name",
      key: "name",
      ellipsis: true,
    },
    {
      title: "연락처",
      // width: 80,
      dataIndex: "phone",
      key: "phone",
      ellipsis: true,
      render: (value) => {
        return value.replaceAll("-", "");
      },
    },
    {
      title: "구매자명",
      // width: 90,
      dataIndex: "created_by_name",
      key: "created_by_name",
      ellipsis: true,
    },
    {
      title: "결제일",
      // width: 160,
      dataIndex: "payment_created_at",
      key: "payment_created_at",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        }
      },
    },
  ];

  useEffect(() => {
    getOrderDeliveryStatus();
    getDeliveryCompanyList();
  }, []);

  useEffect(() => {
    if (searchText && searchText !== " ") {
      setDateType("");
      setSearchOptions({
        ...searchOptions,
        startDate: recordDates.startDate,
        endDate: recordDates.endDate,
        searchStatus: searchText,
      });
      getUserOrderList(
        "custom",
        recordDates.startDate,
        recordDates.endDate,
        searchText,
      );
    }
  }, [searchText]);

  useEffect(() => {
    setOrderList(totalOrderList.slice(offset, offset + pageSize));
  }, [offset, pageSize]);

  useEffect(() => {
    handleChangePagination(currentPageNumber);
  }, [pageSize]);

  useEffect(() => {
    if (searchText && searchText !== " ") {
      getUserOrderList(
        "custom",
        recordDates.startDate,
        recordDates.endDate,
        searchText,
      );
    } else {
      getUserOrderList();
    }
  }, [orderType, orderBy]);

  const getDeliveryCompanyList = async () => {
    setIsLoading(true);
    try {
      const res = await salesManageApi.deliveryCompanyList("delivery_tracker");
      if (res.code === 200) {
        setDeliveryCompanyList(res.result);
      } else {
        alert(
          "해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getDeliveryCompanyList read error", error);
    }
  };

  /**
   * 주문/배송 현황 가져오기
   */
  const getOrderDeliveryStatus = async () => {
    const param = {
      userId: user.id === 724 ? 1 : user.id,
    };
    const res = await salesManageApi.salesManageStatus(param);
    if (res.code === 200) {
      setOrderDeliveryStatus({
        ...orderDeliveryStatus,
        // deliveryShipping: res.result.deliveryShippingCnt,
        // deliveryComplete: res.result.deliveryCompleteCnt
        deliveryShipping: res.result.deliveryShippingList?.length,
        deliveryComplete: res.result.deliveryCompleteList?.length,
      });
    }
  };

  const getUserOrderList = async (
    type = "",
    startDate,
    endDate,
    searchStatus,
  ) => {
    setIsLoading(true);
    try {
      let res;
      if (type === "initial") {
        res = await salesManageApi.searchOrderDetailList(
          0,
          10,
          "delivery",
          searchDateItems[0].searchType,
          moment().subtract(7, "days").startOf("day").format("YYYYMMDDHHmm"),
          moment().endOf("day").format("YYYYMMDDHHmm"),
          orderStatusItems[0].value,
          "",
          "",
          0,
          "",
          "",
          "payment_created_at",
          "desc",
          "",
          "",
          user.id === 724 ? 1 : user.id,
        );
      } else if (type === "search") {
        res = await salesManageApi.searchOrderDetailList(
          0,
          10,
          "delivery",
          searchOptions.searchType,
          searchOptions.startDate.startOf("day").format("YYYYMMDDHHmm"),
          searchOptions.endDate.endOf("day").format("YYYYMMDDHHmm"),
          searchOptions.searchStatus,
          searchOptions.searchOrderId,
          searchOptions.searchProductName,
          searchOptions.funnel,
          searchOptions.name,
          searchOptions.phone.includes("-")
            ? searchOptions.phone.replaceAll("-", "")
            : searchOptions.phone,
          orderType,
          orderBy,
          "",
          "",
          user.id === 724 ? 1 : user.id,
        );
      } else if (type === "custom") {
        res = await salesManageApi.searchOrderDetailList(
          offset,
          pageSize,
          "delivery",
          searchOptions.searchType,
          startDate.startOf("day").format("YYYYMMDDHHmm"),
          endDate.endOf("day").format("YYYYMMDDHHmm"),
          searchStatus,
          searchOptions.searchOrderId,
          searchOptions.searchProductName,
          searchOptions.funnel,
          searchOptions.name,
          searchOptions.phone.includes("-")
            ? searchOptions.phone.replaceAll("-", "")
            : searchOptions.phone,
          orderType,
          orderBy,
          "",
          "",
          user.id === 724 ? 1 : user.id,
        );
      } else {
        res = await salesManageApi.searchOrderDetailList(
          offset,
          pageSize,
          "delivery",
          searchOptions.searchType,
          searchOptions.startDate.startOf("day").format("YYYYMMDDHHmm"),
          searchOptions.endDate.endOf("day").format("YYYYMMDDHHmm"),
          searchOptions.searchStatus,
          searchOptions.searchOrderId,
          searchOptions.searchProductName,
          searchOptions.funnel,
          searchOptions.name,
          searchOptions.phone.includes("-")
            ? searchOptions.phone.replaceAll("-", "")
            : searchOptions.phone,
          orderType,
          orderBy,
          "",
          "",
          user.id === 724 ? 1 : user.id,
        );
      }
      if (res.code === 200) {
        setTotalOrderList(res.result.userOrderDetailDTOList);
        if (type === "initial" || type === "search") {
          setOrderList(res.result.userOrderDetailDTOList.slice(0, 10));
        } else {
          setOrderList(
            res.result.userOrderDetailDTOList.slice(offset, offset + pageSize),
          );
        }
        if (res.result?.length !== 0) {
          setTotalSize(res.result.totalCnt);
        } else {
          setTotalSize(0);
        }
      } else {
        alert(
          "해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getUserOrderList read error", error);
    }
  };

  const changeOrderStatus = async (orderStatus) => {
    setIsLoading(true);
    try {
      let res;
      if (orderStatus === "delivery_shipping") {
        const result = deliveryInfoValidation();
        if (result) {
          const param = {
            userOrderDetailDTOList: Object.values(editDeliveryInfo),
          };
          res = await salesManageApi.orderTrackingNumRegister(param);
        } else {
          alert("배송지 및 송장번호를 입력하지 않는 항목이 있습니다.");
          throw "not valid";
        }
      } else {
        const orderIdSet = new Set(
          selectedRow.map((selectedRow) => selectedRow.order_id),
        );
        const editOrderList = {
          orderIdList: [...orderIdSet],
          orderDetailIdList: selectedRowKey,
          order_status: orderStatus,
          updated_by: user.id === 724 ? 1 : user.id,
        };
        res = await salesManageApi.orderStatusEdit(editOrderList);
      }
      if (res.code === 200) {
        if (orderStatus === "delivery_shipping") {
          const orderIdSet = new Set(
            Object.values(editDeliveryInfo).map(
              (deliveryInfo) => deliveryInfo.order_id,
            ),
          );
          const orderParam = {
            orderIdList: [...orderIdSet],
            orderDetailIdList: Object.values(editDeliveryInfo).map(
              (deliveryInfo) => deliveryInfo.order_detail_id,
            ),
            order_status: orderStatus,
          };
          await sendKakaoAlert(orderParam);
        } else if (orderStatus === "delivery_complete") {
          const orderIdSet = new Set(
            selectedRow.map((selectedRow) => selectedRow.order_id),
          );
          const orderParam = {
            orderIdList: [...orderIdSet],
            orderDetailIdList: selectedRowKey,
            order_status: orderStatus,
          };
          await sendKakaoAlert(orderParam);
        }
        alert("해당 내용이 성공적으로 반영되었습니다.");
        setSelectedRowKey([]);
        setSelectedRow([]);
        getUserOrderList();
        getOrderDeliveryStatus();
      } else if (res.code === 999 || res.code === 405) {
        alert(res.msg);
      } else {
        alert(
          "해당 내용을 수정하는데 실패했습니다. 관리자에게 문의하시길 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("changeOrderStatus edit error", error);
    }
  };

  const editCustomerDeliveryInfo = async () => {
    setIsLoading(true);
    try {
      const param = {
        ...customerDeliveryInfo,
        updated_by: user.id === 724 ? 1 : user.id,
      };
      const res = await salesManageApi.orderDeliveryInfoEdit(param);
      if (res.code === 200) {
        alert("해당 내용이 성공적으로 반영되었습니다.");
      } else if (res.code === 999) {
        alert(res.msg);
      } else {
        alert(
          "해당 내용을 수정하는데 실패했습니다. 관리자에게 문의하시길 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("editCustomerDeliveryInfo edit error", error);
    }
  };

  /**
   * 배송 시작 및 완료 안내 알림톡 보내기
   */
  const sendKakaoAlert = async (orderParam) => {
    try {
      const res = await pushApi.kakaoForDelivery(orderParam);
      if (res.code !== 200) {
        alert(
          "선택한 주문건들에 대해 카카오알림톡을 보내는데 실패하였습니다.\n관리자에게 문의해주시길 바랍니다.",
        );
      } else {
        console.log("sendKakaoAlert success", res.result);
      }
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("sendKakaoAlert alert error", error);
    }
  };

  /**
   * 구매확정 Point 적립
   */
  const purchasePointComplete = async () => {
    setIsLoading(true);
    try {
      const orderIdSet = new Set(
        selectedRow.map((selectedRow) => selectedRow.order_id),
      );
      const param = {
        orderIdList: [...orderIdSet],
      };
      const res = await salesManageApi.purchasePointComplete(param);
      if (res.code !== 200) {
        alert(
          `선택한 "${[...orderIdSet].join(
            ",",
          )}" 주문건들의 구매 확정 포인트 지급에 실패하였습니다.\n관리자에게 문의해주시길 바랍니다.`,
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("purchasePointComplete publish error", error);
    }
  };

  /**
   * handle dateType change
   */
  const handleDateTypeChange = (e) => {
    const value = e.target.value;
    setDateType(value);
    switch (value) {
      case "today":
        setSearchOptions({
          ...searchOptions,
          startDate: moment().startOf("day"),
          endDate: moment().endOf("day"),
        });
        break;
      case "1week":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(7, "days").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(7, "days")
              .startOf("day"),
          });
        }
        break;
      case "1month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(1, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(1, "months")
              .startOf("day"),
          });
        }
        break;
      case "3month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(3, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(3, "months")
              .startOf("day"),
          });
        }
        break;
      case "6month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(6, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(6, "months")
              .startOf("day"),
          });
        }
        break;
    }
  };

  /**
   * 검색
   */
  const handleSearch = () => {
    setOffset(0);
    setCurrentPageNumber(1);
    if (searchOptions.startDate === null || searchOptions.endDate === null) {
      alert("조회하려는 기간이 없습니다. 다시 설정해주시길 바랍니다.");
    } else {
      if (!searchOptions.startDate.isBefore(searchOptions.endDate)) {
        alert(
          "조회하려는 기간이 잘못 설정되어있습니다. 다시 시도해주시길 바랍니다.",
        );
      } else {
        setIsSearchText("");
        setDates({
          startDate: moment().format("YYYY-MM-DD"),
          endDate: moment().add(1, "d").format("YYYY-MM-DD"),
        });
        getUserOrderList("search");
      }
    }
  };

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      searchType: searchDateItems[0].searchType,
      searchStatus: orderStatusItems[0].value,
      searchOrderId: "",
      searchProductName: "",
      funnel: 0,
      name: "",
      phone: "",
      startDate: moment().subtract(7, "days").startOf("day"),
      endDate: moment().endOf("day"),
    });
    setDateType(dateTypeItems[1].value);
    setOffset(0);
    setPageSize(10);
    setSelectedRowKey([]);
    setSelectedRow([]);
    setIsSearchText("");
    setDates({
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().add(1, "d").format("YYYY-MM-DD"),
    });
    getUserOrderList("initial");
  };

  const tableOnChange = (pagination, filters, sorter, extra) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === "descend") {
          setOrderBy("desc");
        } else if (sorter.order === "ascend") {
          setOrderBy("asc");
        }
        setOrderType(sorter.field);
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType("payment_created_at");
        setOrderBy("desc");
      }
    }
  };

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    const currOffset = (pageNumber - 1) * pageSize;
    setCurrentPageNumber(pageNumber);
    setOffset(currOffset);
  };

  /**
   * pageSize 변경 handler
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
    setOffset((current - 1) * pageSize);
  };

  const handleDeliveryInfoChange = (e) => {
    const { name, value } = e.target;
    setCustomerDeliveryInfo({ ...customerDeliveryInfo, [name]: value });
  };

  const customerDeliveryInfoSetting = () => {
    if (selectedRow[0].order_detail_status === "delivery_ready") {
      setCustomerDeliveryInfo({
        id: selectedRow[0].order_id,
        name: selectedRow[0].name,
        address: selectedRow[0].address,
        address_detail: selectedRow[0].address_detail,
        phone: selectedRow[0].phone,
        postal_code: selectedRow[0].postal_code,
      });
      setIsModalOpen(true);
    } else {
      alert(
        "배송지 정보 수정은 발송처리 이전까지만 가능합니다.\n선택하신 주문 건은 발송처리가 진행되어 배송지 수정이 불가능합니다.",
      );
    }
  };

  /**
   * excel download
   */
  const handleExcelDownloadClick = () => {
    try {
      let excelData;
      if (selectedRow?.length !== 0) {
        excelData = selectedRow.map((row) => {
          return {
            order_id: `DY${row.order_id}`,
            order_detail_id: `dy${row.order_detail_id}`,
            payment_created_at: moment(row.payment_created_at).format(
              "YYYY.MM.DD HH:mm",
            ),
            order_detail_status:
              status.matchingOrderStatus[row.order_detail_status],
            product_id: row.product_id,
            product_name: row.product_name,
            option_id: row.option_id,
            option_title: row.option_title,
            quantity: row.quantity,
            total_price: row.total_price,
            price: row.price,
            coupon_discount_price: row.coupon_discount_price,
            created_by_name: row.created_by_name,
            use_point: row.use_point ? "Y" : "N",
            name: row.name,
            phone: row.phone,
            address:
              row.address +
              (row.address_detail ? `, ${row.address_detail}` : ""),
            address_request:
              row.address_request === "배송 시 요청사항을 선택해주세요."
                ? ""
                : row.address_request,
            delivery_company: status.matchingDeliveryCompany[
              row.delivery_company
            ]
              ? status.matchingDeliveryCompany[row.delivery_company]
              : row.delivery_company,
            tracking_number: row.tracking_number,
            ship_date: row.ship_date
              ? moment(row.ship_date).format("YYYY.MM.DD")
              : row.ship_date,
          };
        });
      } else if (totalOrderList?.length !== 0) {
        excelData = totalOrderList.map((row) => {
          return {
            order_id: `DY${row.order_id}`,
            order_detail_id: `dy${row.order_detail_id}`,
            payment_created_at: moment(row.payment_created_at).format(
              "YYYY.MM.DD HH:mm",
            ),
            order_detail_status:
              status.matchingOrderStatus[row.order_detail_status],
            product_id: row.product_id,
            product_name: row.product_name,
            option_id: row.option_id,
            option_title: row.option_title,
            quantity: row.quantity,
            total_price: row.total_price,
            price: row.price,
            coupon_discount_price: row.coupon_discount_price,
            created_by_name: row.created_by_name,
            use_point: row.use_point ? "Y" : "N",
            name: row.name,
            phone: row.phone,
            address:
              row.address +
              (row.address_detail ? `, ${row.address_detail}` : ""),
            address_request:
              row.address_request === "배송 시 요청사항을 선택해주세요."
                ? ""
                : row.address_request,
            delivery_company: status.matchingDeliveryCompany[
              row.delivery_company
            ]
              ? status.matchingDeliveryCompany[row.delivery_company]
              : row.delivery_company,
            tracking_number: row.tracking_number,
            ship_date: row.ship_date
              ? moment(row.ship_date).format("YYYY.MM.DD")
              : row.ship_date,
          };
        });
      } else {
        alert(
          "다운받으려는 데이터가 없습니다. 조회 후 다시 시도해주시길 바랍니다.",
        );
        throw "no data";
      }
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(excelData);
      Object.keys(excelData[0]).forEach((key, idx) => {
        const cellAdd = XLSX.utils.encode_cell({ c: idx, r: 0 });
        ws[cellAdd].v = status.matchingKey[key];
      });
      XLSX.utils.book_append_sheet(wb, ws, "배송현황관리");
      XLSX.writeFile(wb, `${moment().format("YYYYMMDD")}_배송현황관리.xlsx`);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("handleExcelDownloadClick edit error", error);
    }
  };

  /**
   * 구매확정 처리 함수
   */
  const handleChangeComplete = async () => {
    const validResult = selectedRow.map((row) => {
      if (
        row.delivery_company === null ||
        row.delivery_company === "" ||
        row.tracking_number === null ||
        row.tracking_number === "" ||
        row.ship_date === null ||
        row.ship_date === "" ||
        row.order_detail_status !== "delivery_complete"
      ) {
        return false;
      } else {
        return true;
      }
    });
    if (validResult.every((valid) => valid)) {
      await changeOrderStatus("complete");
      purchasePointComplete();
    } else {
      if (
        window.confirm(
          "선택한 항목들 중에 주문상태가 '배송완료'인 상태가 아니거나\n송장번호가 없는 항목들이 있습니다.\n그래도 선택하신 항목들을 구매확정 처리하시겠습니까?",
        )
      ) {
        await changeOrderStatus("complete");
        purchasePointComplete();
      }
    }
  };

  /**
   * 고객 배송지 정보수정 Modal click OK handler
   */
  const handleOk = async () => {
    if (
      customerDeliveryInfo.name === null ||
      customerDeliveryInfo.name === "" ||
      customerDeliveryInfo.address === null ||
      customerDeliveryInfo.address === ""
    ) {
      alert(
        "정보 수정하는데 필요한 값들이 채워지지 않았습니다. 다시 시도해주시길 바랍니다.",
      );
    } else {
      await editCustomerDeliveryInfo();
      setCustomerDeliveryInfo({});
      setSelectedRowKey([]);
      setSelectedRow([]);
      setIsModalOpen(false);
      getUserOrderList();
    }
  };

  /**
   * 고객 배송지 정보수정 Modal click cancel handler
   */
  const handleCancel = () => {
    setCustomerDeliveryInfo({});
    setIsModalOpen(false);
  };

  /**
   * 송장엑셀업로드 Modal click cancel handler
   */
  const handleExcelUploadCancel = () => {
    setUploadExcelDataHeader([]);
    setUploadExcelData([]);
    setIsDeliveryShippingModalOpen(false);
    setValidation(false);
  };

  /**
   * 업로드된 송장 엑셀 유효성 체크
   */
  const handleExcelValidation = async () => {
    setIsLoading(true);
    try {
      if (uploadExcelData?.length > 1) {
        let nonExistentRowList = [];
        let orderIdList = [];
        let duplicateOrderIdList = [];
        const dataKeys = uploadExcelData.shift();
        setUploadExcelDataHeader(dataKeys);
        for (const data of uploadExcelData) {
          let validValueList = [];
          Object.keys(dataKeys).forEach((key) => {
            switch (key) {
              case "개별상품주문번호":
                if (data.hasOwnProperty(key)) {
                  if (orderIdList.includes(data[key])) {
                    duplicateOrderIdList.push(data[key]);
                    validValueList.push(true);
                  } else {
                    orderIdList.push(data[key].replace("dy", ""));
                    validValueList.push(true);
                  }
                } else {
                  validValueList.push(false);
                }
                break;
              case "택배사":
                if (data.hasOwnProperty(key)) {
                  if (
                    Object.values(status.matchingDeliveryCompany).includes(
                      data[key],
                    )
                  ) {
                    validValueList.push(true);
                  } else {
                    validValueList.push(false);
                  }
                } else {
                  validValueList.push(false);
                }
                break;
              case "발송일":
                if (data.hasOwnProperty(key)) {
                  if (typeof data[key] !== "string") {
                    validValueList.push(false);
                  } else {
                    if (/\d{4}-\d{2}-\d{2}/.test(data[key])) {
                      validValueList.push(true);
                    } else {
                      validValueList.push(false);
                    }
                  }
                }
                break;
              // default:
              //     if (data.hasOwnProperty(key)) {
              //         validValueList.push(true)
              //     } else {
              //         validValueList.push(false)
              //     }
              //     break;
            }
          });
          if (
            !data.hasOwnProperty("택배사") ||
            !data.hasOwnProperty("송장번호")
          ) {
            nonExistentRowList.push(data.__rowNum__ + 1);
          } else {
            if (!validValueList.every((result) => result)) {
              nonExistentRowList.push(data.__rowNum__ + 1);
            }
          }
        }
        if (nonExistentRowList?.length !== 0) {
          throw `${nonExistentRowList.join(
            "행, ",
          )}행의 값이 비어있거나 올바른 형식이 아닙니다.\n올바른 파일을 다시 업로드해주세요`;
        } else if (duplicateOrderIdList?.length !== 0) {
          throw `개별주문번호가 ${duplicateOrderIdList.join(
            ", ",
          )}인 행이 중복되어있습니다.\n확인 후 올바른 파일을 다시 업로드해주세요`;
        } else {
          const res = await salesManageApi.isPossibleUploadTrackingNumber({
            orderDetailIdList: orderIdList,
          });
          if (res.code === 200) {
            if (res.result === 0) {
              setIsLoading(false);
              alert("엑셀 유효성검사가 완료되었습니다.");
              setValidation(true);
            } else {
              throw "주문항목들 중 주문상태가 배송준비중이거나 배송중이 아닌 항목들이 존재합니다.\n확인 후 올바른 파일을 다시 업로드해주세요";
            }
          } else {
            throw "해당 주문건들에 대한 주문 상태를 확인하는데 실패하였습니다.\n새로고침 후 다시 업로드 진행해주시길 바랍니다.";
          }
        }
      } else {
        throw "업로드할 데이터가 없습니다.\n데이터를 입력하거나 템플릿 수정 후 다시 업로드해주세요";
      }
    } catch (e) {
      setIsLoading(false);
      setError(error);
      console.log("handleExcelValidation validation error", e);
      alert(e);
      setTimeout(() => {
        handleExcelUploadCancel();
      }, 1000);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * 송장 엑셀 데이터 formatting
   * + 상품주문번호에 DY 지우기 (2023.12.11) - ksb
   */
  const handleExcelUpload = async () => {
    setIsLoading(true);
    const dataFormatting = uploadExcelData.map((excelData) => {
      let returnValue = {};
      Object.keys(uploadExcelDataHeader).forEach((key) => {
        if (key === "택배사") {
          returnValue[uploadExcelDataHeader[key]] = Object.keys(
            status.matchingDeliveryCompany,
          ).find(
            (companyKey) =>
              status.matchingDeliveryCompany[companyKey] === excelData[key],
          );
        } else if (key === "발송일") {
          if (excelData[key]) {
            returnValue[uploadExcelDataHeader[key]] = moment(excelData[key]);
          } else {
            returnValue[uploadExcelDataHeader[key]] = moment();
          }
        } else if (key === "개별상품주문번호") {
          returnValue[uploadExcelDataHeader[key]] = excelData[key].replace(
            "dy",
            "",
          );
        } else if (key === "수취인명") {
          /* empty */
        } else if (key === "상품주문번호") {
          returnValue[uploadExcelDataHeader[key]] = excelData[key].replace(
            "DY",
            "",
          );
        } else {
          returnValue[uploadExcelDataHeader[key]] = excelData[key];
        }
      });
      returnValue["order_detail_status"] = "delivery_shipping";
      returnValue["updated_by"] = user.id === 724 ? 1 : user.id;
      return returnValue;
    });
    try {
      const res = await salesManageApi.orderTrackingNumRegister({
        userOrderDetailDTOList: dataFormatting,
      });
      if (res.code === 200 && res.result) {
        const orderIdSet = new Set(
          res.result.map((deliveryInfo) => deliveryInfo.order_id),
        );
        const orderParam = {
          orderIdList: [...orderIdSet],
          orderDetailIdList: dataFormatting.map((deliveryInfo) =>
            deliveryInfo.order_detail_id.replace("dy", ""),
          ),
          order_status: "delivery_shipping",
        };
        await sendKakaoAlert(orderParam);
        alert("해당 내용이 성공적으로 반영되었습니다.");
        getUserOrderList();
        setTimeout(() => {
          handleExcelUploadCancel();
        }, 1000);
      } else if (res.code === 999 || res.code === 405) {
        alert(res.msg);
      } else {
        alert(
          "해당 내용을 수정하는데 실패했습니다. 관리자에게 문의하시길 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("handleExcelUpload edit error", error);
    }
  };

  /**
   * Post Code 입력하기 (다음 주소 api)
   * @param data
   */
  const handlePostCode = (data) => {
    let fullAddress = data.address;
    let extraAddress = "";

    if (data.addressType === "R") {
      if (data.bname !== "") {
        extraAddress += data.bname;
      }
      if (data.buildingName !== "") {
        extraAddress +=
          extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
    }

    if (fullAddress?.length > 0) {
      setCustomerDeliveryInfo({
        ...customerDeliveryInfo,
        postal_code: data.zonecode,
        address: fullAddress,
      });
    }
    setIsPostalCodeModalOpen(false); // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
  };

  /**
   * 엑셀 일괄 발송처리 > 업로드된 엑셀 읽기
   */
  const readExcelData = (e) => {
    if (e.target.value !== "") {
      let reader = new FileReader();
      reader.onload = () => {
        let fileData = reader.result;
        let wb = XLSX.read(fileData, {
          type: "binary",
          cellDates: true,
          dateNF: "YYYY-MM-DD",
        });
        let sheetNameList = wb.SheetNames;
        let firstSheet = wb.Sheets[sheetNameList[0]];

        let data = XLSX.utils.sheet_to_json(firstSheet, { raw: false });
        setUploadExcelData(data);
      };
      reader.readAsBinaryString(e.target.files[0]);
    } else {
      setUploadExcelData([]);
    }
  };

  const deliveryInfoValidation = () => {
    const validResult = Object.values(editDeliveryInfo).map((deliveryInfo) => {
      if (
        deliveryInfo.delivery_company === null ||
        deliveryInfo.delivery_company === "" ||
        deliveryInfo.tracking_number === null ||
        deliveryInfo.tracking_number === "" ||
        deliveryInfo.ship_date === null ||
        deliveryInfo.ship_date === ""
      ) {
        return false;
      } else {
        return true;
      }
    });
    return validResult.every((valid) => valid);
  };

  /**
   * 주문 상세 Modal cancel handler
   */
  const handleOrderDetailModalCancel = () => {
    setIsOrderModalOpen(false);
    setOrderDetail({});
  };

  const disabledDeliveryShipping = () => {
    if (selectedRow?.length === 0) {
      return true;
    } else {
      return !selectedRow.every(
        (row) =>
          row.order_detail_status === "delivery_ready" ||
          row.order_detail_status === "delivery_shipping",
      );
    }
  };

  const disabledDeliveryComplete = () => {
    if (selectedRow?.length === 0) {
      return true;
    } else {
      return !selectedRow.every(
        (row) => row.order_detail_status === "delivery_shipping",
      );
    }
  };

  const disabledComplete = () => {
    if (selectedRow?.length === 0) {
      return true;
    } else {
      return !selectedRow.every(
        (row) => row.order_detail_status !== "complete",
      );
    }
  };

  const disabledValidationBtn = () => {
    if (uploadExcelData?.length !== 0 && !validation) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <>
      <ContentHeaderComponent title="배송현황관리" />
      <div className="product-register-wrap">
        {/*배송현황상태*/}
        <Row className="product-search-product-status-wrap">
          {/*배송중*/}
          <Col span={12} md={5}>
            <Row className="product-status-box-wrap">
              <img
                className="product-status-icon"
                src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/delivery_shipping_icon.png`}
              />
              <div className="product-status-text">
                <div>배송중</div>
                <div>
                  <span className="product-status-num">
                    {orderDeliveryStatus.deliveryShipping}
                  </span>{" "}
                  건
                </div>
              </div>
            </Row>
          </Col>

          {/*배송완료*/}
          <Col span={12} md={5}>
            <Row className="product-status-box-wrap">
              <img
                className="product-status-icon"
                src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/delivery_complete_icon.png`}
              />
              <div className="product-status-text">
                <div>배송완료</div>
                <div>
                  <span className="product-status-num">
                    {orderDeliveryStatus.deliveryComplete}
                  </span>{" "}
                  건
                </div>
              </div>
            </Row>
          </Col>
        </Row>

        {/*배송현황검색*/}
        <div className="product-search-box-wrap">
          <Form.Item
            label="조회기간"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchType}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchType: value })
              }
              style={{ width: 120, textAlign: "left" }}
            >
              {searchDateItems.map((item, idx) => (
                <Option
                  key={`order_date_search_${idx}`}
                  value={item.searchType}
                >
                  {item.searchText}
                </Option>
              ))}
            </Select>
            <Row align={"middle"} style={{ marginTop: 10, gap: "5px" }}>
              <Radio.Group
                className={`options-list`}
                options={dateTypeItems}
                onChange={handleDateTypeChange}
                value={dateType}
                optionType="button"
              />
              <DatePicker
                className="order-search-date-wrap"
                format="YYYY/MM/DD"
                value={searchOptions.startDate}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, startDate: value });
                }}
              />
              ~
              <DatePicker
                className="order-search-date-wrap"
                format="YYYY/MM/DD"
                value={searchOptions.endDate}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, endDate: value });
                }}
              />
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="주문상태"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchStatus}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchStatus: value })
              }
              style={{ width: 250, textAlign: "left" }}
            >
              {orderStatusItems.map((item, idx) => (
                <Option key={`order_status_search_${idx}`} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="유입경로"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Radio.Group
              options={funnelStatusItems}
              onChange={(e) =>
                setSearchOptions({ ...searchOptions, funnel: e.target.value })
              }
              value={searchOptions.funnel}
            />
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            label="상세검색"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align="middle">
              <Col sm={5} md={2}>
                <div className="content-search-wrap">주문번호</div>
              </Col>
              <Col style={{ marginRight: "2rem" }}>
                <Input
                  name="searchOrderId"
                  value={searchOptions.searchOrderId}
                  onChange={(e) => {
                    const reg = /^[0-9]*$/;
                    if (reg.test(e.target.value) || e.target.value === "") {
                      setSearchOptions({
                        ...searchOptions,
                        [e.target.name]: e.target.value,
                      });
                    }
                  }}
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className="content-search-wrap">상품명</div>
              </Col>
              <Col style={{ marginRight: "2rem" }}>
                <Input
                  name="searchProductName"
                  value={searchOptions.searchProductName}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
            <Row align="middle" style={{ marginTop: 10 }}>
              <Col sm={5} md={2}>
                <div className="content-search-wrap">이름</div>
              </Col>
              <Col style={{ marginRight: "2rem" }}>
                <Input
                  name="name"
                  value={searchOptions.name}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className="content-search-wrap">연락처</div>
              </Col>
              <Col>
                <Input
                  name="phone"
                  value={searchOptions.phone}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Row className="product-search-button-wrap" justify="center">
            <Button
              className="product-search-button search"
              onClick={handleSearch}
            >
              검색
            </Button>
            <Button
              className="product-search-button initial"
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/*주문목록*/}
        <Row
          className="product-register-border-box"
          justify={"space-between"}
          wrap={false}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <div>
            <span className="product-register-box-title">
              주문목록 (총{" "}
              <span
                className="product-register-box-subtitle"
                style={{ marginLeft: 0 }}
              >
                {totalSize}
              </span>
              개)
            </span>
            <span className="product-list-subtitle">
              {orderPair[orderType]}
            </span>
          </div>
          <div>
            <Button
              className="order-excel-download-btn"
              icon={
                <img
                  style={{ height: 14.2, width: 14.5, marginRight: 5 }}
                  src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/microsoftexcel.png`}
                />
              }
              onClick={handleExcelDownloadClick}
            >
              엑셀다운
            </Button>
          </div>
        </Row>
        <Row
          className="product-register-border-box"
          justify={"space-between"}
          wrap={false}
        >
          <div>
            <Button
              className="order-status-change-button"
              disabled={disabledDeliveryShipping()}
              onClick={() => changeOrderStatus("delivery_shipping")}
            >
              발송처리
            </Button>
            <Button
              className="order-status-change-button"
              onClick={() => setIsDeliveryShippingModalOpen(true)}
            >
              엑셀 일괄 발송처리
            </Button>
            <Button
              className="order-status-change-button"
              disabled={disabledDeliveryComplete()}
              onClick={() => changeOrderStatus("delivery_complete")}
            >
              배송완료 처리
            </Button>
            <Button
              className="order-status-change-button"
              disabled={disabledComplete()}
              onClick={handleChangeComplete}
            >
              구매확정 처리
            </Button>
          </div>
          <div>
            <Button
              className="order-status-change-button"
              onClick={() => history.push("/salesManage/purchaseComfirmation")}
            >
              구매확정 후 취소처리 바로가기
              <img
                style={{ height: 14.2, width: 14.5 }}
                src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/Icon.png`}
              />
            </Button>
          </div>
        </Row>
        <div
          className="product-register-border-box"
          wrap={false}
          style={{
            borderTop: 0,
            borderBottom: 0,
            padding: "20px 25px 40px",
            height: "fit-content",
          }}
        >
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={orderList}
            loading={isLoading}
            bordered
            size="middle"
            rowKey="order_detail_id"
            rowClassName="coupon-table-row"
            scroll={{ x: "max-content" }}
            tableLayout={"auto"}
            onChange={tableOnChange}
            pagination={false}
          />

          <div style={{ textAlign: "right" }}>
            <Pagination
              showSizeChanger
              pageSize={pageSize}
              onShowSizeChange={pageSizeChange}
              total={totalSize}
              onChange={handleChangePagination}
              style={{ marginTop: 20 }}
              current={currentPageNumber}
            />
          </div>
        </div>
        <div
          className="product-register-border-box"
          style={{
            backgroundColor: "#f8f9fd",
            height: "fit-content",
            padding: "15px 25px",
          }}
        >
          <Form.Item
            className="order-bottom-form-item center-label"
            label="배송현황 관리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row>
              <Button
                className="order-status-change-button"
                onClick={() => setIsDeliveryShippingModalOpen(true)}
              >
                엑셀 일괄 발송처리
              </Button>
              <Button
                className="order-status-change-button"
                disabled={disabledDeliveryComplete()}
                onClick={() => changeOrderStatus("delivery_complete")}
              >
                배송완료 처리
              </Button>
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider order-bottom-divider-margin" />
          <Form.Item
            className="order-bottom-form-item center-label"
            label="구매확정 관리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row>
              <Button
                className="order-status-change-button"
                disabled={disabledComplete()}
                onClick={handleChangeComplete}
              >
                구매확정 처리
              </Button>
            </Row>
          </Form.Item>
          {/*<Divider className="product-register-form-input-divider order-bottom-divider-margin" />*/}
          {/*<Form.Item*/}
          {/*    className="order-bottom-form-item"*/}
          {/*    label="교환/반품"*/}
          {/*    labelAlign="left"*/}
          {/*    colon={false}*/}
          {/*    labelCol={{ span: 3 }}*/}
          {/*    wrapperCol={{ span: 21 }}*/}
          {/*>*/}
          {/*    <Row>*/}
          {/*        <Button className="order-status-change-button" disabled={disabledDeliveryShipping()} onClick={() => changeOrderStatus("delivery_shipping")}>판매자 직접 반품</Button>*/}
          {/*        <Button className="order-status-change-button" onClick={() => setIsDeliveryShippingModalOpen(true)}>엑셀 일괄 발송처리</Button>*/}
          {/*    </Row>*/}
          {/*    <div style={{ marginTop: 10 }}>* 배송사 및 송장번호 입력 후, 발송처리를 눌러주세요.</div>*/}
          {/*</Form.Item>*/}
          <Divider className="product-register-form-input-divider order-bottom-divider-margin" />
          <Form.Item
            className="order-bottom-form-item center-label"
            label="정보수정"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row>
              <Button
                className="order-status-change-button"
                disabled={disabledDeliveryShipping()}
                onClick={() => changeOrderStatus("delivery_shipping")}
              >
                발송처리
              </Button>
              <Button
                className="order-status-change-button"
                disabled={selectedRowKey?.length !== 1}
                onClick={customerDeliveryInfoSetting}
              >
                고객 배송지 정보수정
              </Button>
            </Row>
          </Form.Item>
        </div>

        {/*고객배송지정보수정Modal*/}
        {selectedRow?.length !== 0 &&
        Object.keys(customerDeliveryInfo)?.length !== 0 ? (
          <Modal
            title="고객 배송지 정보수정"
            visible={isModalOpen}
            centered={true}
            cancelText={<span>취소</span>}
            okText={<span>정보 수정</span>}
            onOk={handleOk}
            onCancel={handleCancel}
            // width={"80%"}
          >
            <Form.Item
              label="수령자명"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Input
                name="name"
                value={customerDeliveryInfo.name}
                onChange={handleDeliveryInfoChange}
              />
            </Form.Item>
            <Form.Item
              label="연락처"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <Input
                name="phone"
                value={customerDeliveryInfo.phone}
                onChange={handleDeliveryInfoChange}
              />
            </Form.Item>
            <Form.Item
              label="우편번호"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <Row justify={"space-between"} style={{ width: "100%" }}>
                <Col span={10}>
                  <Input
                    name="postal_code"
                    value={customerDeliveryInfo.postal_code}
                    onChange={handleDeliveryInfoChange}
                  />
                </Col>
                <Col span={"auto"}>
                  <Button onClick={() => setIsPostalCodeModalOpen(true)}>
                    우편번호 검색
                  </Button>
                </Col>
              </Row>
            </Form.Item>
            <Form.Item
              label="주소"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Input
                name="address"
                value={customerDeliveryInfo.address}
                onChange={handleDeliveryInfoChange}
              />
            </Form.Item>
            <Form.Item
              label="상세주소"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <Input
                name="address_detail"
                value={customerDeliveryInfo.address_detail}
                onChange={handleDeliveryInfoChange}
              />
            </Form.Item>
          </Modal>
        ) : null}

        {/*우편번호검색Modal*/}
        {isPostalCodeModalOpen && (
          <Modal
            className="order-postal-code-modal"
            visible={isPostalCodeModalOpen}
            onCancel={() => setIsPostalCodeModalOpen(false)}
            footer={null}
          >
            <DaumPostcodeEmbed
              style={{
                height: "450px",
              }}
              submitMode={false}
              onComplete={handlePostCode}
            />
          </Modal>
        )}

        {/*송장 엑셀 일괄 발송처리Modal*/}
        {isDeliveryShippingModalOpen && (
          <Modal
            className="order-tracking-number-modal"
            title="엑셀 일괄 발송처리"
            visible={isDeliveryShippingModalOpen}
            onCancel={handleExcelUploadCancel}
            footer={[
              <Button
                key="back"
                onClick={handleExcelUploadCancel}
                loading={isLoading}
                disabled={isLoading}
              >
                돌아가기
              </Button>,
              <Button
                type="primary"
                loading={isLoading}
                disabled={disabledValidationBtn()}
                onClick={handleExcelValidation}
              >
                유효성검사하기
              </Button>,
              <Button
                key="submit"
                type="primary"
                loading={isLoading}
                disabled={!validation}
                onClick={handleExcelUpload}
              >
                자료업로드하기
              </Button>,
            ]}
          >
            <p>* 업로드할 엑셀파일을 선택해주세요(.xlsx)</p>
            <p>* 일괄발송처리 전용 파일 양식을 통한 등록도 가능합니다.</p>
            <Button
              className="excel-template-download-btn"
              href={`${process.env.REACT_APP_HOST}/assets/files/TrackingNumber_Template.xlsx`}
            >
              일괄발송처리 양식 다운 >
            </Button>
            <input
              disabled={validation}
              type={"file"}
              id="excelFile"
              onChange={readExcelData}
            />
          </Modal>
        )}
      </div>

      {/*주문 상세 페이지*/}
      {isOrderModalOpen && (
        <Modal
          title="상품주문정보 조회"
          wrapClassName="order-detail-modal-wrap"
          visible={isOrderModalOpen}
          centered={true}
          onCancel={handleOrderDetailModalCancel}
          footer={null}
          width="70%"
        >
          <OrderDetailComponent
            orderDetail={orderDetail}
            handleOrderDetailModalCancel={handleOrderDetailModalCancel}
            getUserOrderList={getUserOrderList}
          />
        </Modal>
      )}
    </>
  );
};

export default DeliveryManageComponet;
